import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
import { standardFunctions } from '@/Configurator/Composables/standardFunctions';
import axios from 'axios';
import { Canvas, Circle, util } from 'fabric';
import { onMounted, ref } from 'vue';
//TODO: Funktionen aus Konfiguration und Vorschau zusammen auslagern, ggf. einzelne Komponenten pro Vorschauobjekt, um modularer zu arbeiten
export default /*@__PURE__*/ _defineComponent({
    __name: 'LidConfigurationPreview',
    props: {
        configurationId: String,
        tenantId: String,
        lid: Object,
        previewWidth: Number
    },
    setup(__props) {
        let { mmToPx } = standardFunctions();
        const props = __props;
        const configurationKey = ref(Math.random().toString(36).substring(7));
        // PREVIEW
        const scaleFactor = ref(1); //Scale Faktor?
        const exactPreviewWidth = ref(500); //Genauigkeit der Vorschau Breite
        const configurationComponentId = ref('000000'); //Konfigurationskomponenten ID
        const lidWidth = ref(0); //Deckelbreite in mm
        const lidDepth = ref(0); //Deckelhöhe in mm
        // const lidDiameter = ref(0); //Deckeldurchmesser in mm
        const printWidth = ref(0); //Druckbereich Breite in mm
        const printHeight = ref(0); //Druckbereich Höhe in mm
        const lidConfigImageSrc = ref(''); //Deckelkonfiguration Bild
        const lidConfigColor = ref(null); //Deckelkonfiguration Farbe
        const lidCanvas = ref(new Canvas()); //Verschluss Druckbereich
        const lidPreview = ref(new Canvas()); //Verschluss Vorschau
        const lidCanvasPreview = ref(''); //Verschluss Druckbereich Vorschau
        onMounted(() => {
            exactPreviewWidth.value = props.previewWidth ?? 500;
            loadConfiguration();
        });
        function loadConfiguration() {
            if (props.lid == null) {
                return;
            }
            axios.post(route('configurator.lidConfiguration.load', props.configurationId), {
                lidId: props.lid.id,
            })
                .then(function (response) {
                configurationComponentId.value = response.data.id;
                lidWidth.value = response.data.lid.width;
                lidDepth.value = response.data.lid.depth;
                // lidDiameter.value = response.data.lid.diameter;
                printWidth.value = response.data.lid.printWidth;
                printHeight.value = response.data.lid.printHeight;
                lidConfigImageSrc.value = response.data.lid.configImage;
                lidConfigColor.value = response.data.lid.configColor;
                scaleFactor.value = mmToPx(lidWidth.value) / exactPreviewWidth.value;
                if (lidCanvas.value) {
                    lidCanvas.value.clear();
                    lidCanvas.value.dispose();
                }
                lidCanvas.value = new Canvas('', {
                    width: mmToPx(printWidth.value) / scaleFactor.value,
                    height: mmToPx(printHeight.value) / scaleFactor.value
                });
                assembleImages();
                loadPrintConfigurationData(); //Load print configuration data if already saved
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadPrintConfigurationData() {
            if (configurationComponentId.value) {
                axios.post(route('configurator.printConfiguration.load', configurationComponentId.value), {
                    configurationType: 'lid'
                })
                    .then(function (response) {
                    if (response.data.configuration) {
                        new Canvas()
                            .loadFromJSON(response.data.configuration)
                            .then((canvas) => {
                            lidCanvas.value.clear();
                            // Neue Canvas-Größe (falls sie sich geändert hat)
                            const newWidth = lidCanvas.value.width;
                            const newHeight = lidCanvas.value.height;
                            // Originalgröße aus gespeicherten Daten
                            const originalWidth = canvas.width;
                            const originalHeight = canvas.height;
                            // Skalierungsfaktoren berechnen
                            const scaleX = newWidth / originalWidth;
                            const scaleY = newHeight / originalHeight;
                            canvas.getObjects().forEach((obj) => {
                                // Skalierung anpassen
                                obj.scaleX = (obj.scaleX || 1) * scaleX;
                                obj.scaleY = (obj.scaleY || 1) * scaleY;
                                obj.left = (obj.left || 0) * scaleX;
                                obj.top = (obj.top || 0) * scaleY;
                                obj.setCoords();
                                lidCanvas.value.add(obj);
                            });
                            lidCanvas.value.renderAll();
                            lidCanvasPreview.value = util.toDataURL(lidCanvas.value.getElement(), 'png', 1);
                            // lidCanvasPreview.value = lidCanvas.value.toSVG();
                        });
                    }
                })
                    .catch(function (error) {
                    console.log(error);
                });
            }
        }
        function assembleImages() {
            var previewWidth = mmToPx(lidWidth.value) / scaleFactor.value;
            var previewHeight = mmToPx(lidDepth.value) / scaleFactor.value;
            if (lidPreview.value) {
                lidPreview.value.clear();
                lidPreview.value.dispose();
            }
            lidPreview.value = new Canvas('lid-bg-container-preview-' + configurationKey.value, {
                width: previewWidth,
                height: previewHeight
            });
            var lidConfigImg = new Circle({
                radius: previewWidth / 2,
                fill: lidConfigColor.value,
                opacity: 0.8,
                selectable: false
            });
            lidPreview.value.add(lidConfigImg);
            lidPreview.value.sendObjectToBack(lidConfigImg);
            lidPreview.value.renderAll();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "d-flex justify-content-center align-items-center",
                style: _normalizeStyle([{ "background-size": "cover" }, { width: _unref(mmToPx)(lidWidth.value) / scaleFactor.value + 'px', height: _unref(mmToPx)(lidDepth.value) / scaleFactor.value + 'px', backgroundImage: 'url(' + lidConfigImageSrc.value + ')' }])
            }, [
                _createElementVNode("canvas", {
                    id: 'lid-bg-container-preview-' + configurationKey.value
                }, null, 8, _hoisted_1),
                _createElementVNode("div", {
                    style: _normalizeStyle({ width: _unref(mmToPx)(printWidth.value) / scaleFactor.value + 'px', height: _unref(mmToPx)(printHeight.value) / scaleFactor.value + 'px', backgroundImage: 'url(' + lidCanvasPreview.value + ')' }),
                    class: "position-absolute"
                }, null, 4)
            ], 4));
        };
    }
});
